import React, { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Star, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Profil() {
  const [favorites, setFavorites] = useState([]);
  const [form, setForm] = useState({ label: "", address: "" });

  const load = () => api.get("/patient/favorites").then((r) => setFavorites(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.label || !form.address) { toast.error("Renseignez un libellé et une adresse"); return; }
    try {
      await api.post("/patient/favorites", form);
      setForm({ label: "", address: "" });
      toast.success("Adresse ajoutée");
      load();
    } catch (err) { toast.error(apiError(err)); }
  };

  const remove = async (id) => { await api.delete(`/patient/favorites/${id}`); load(); };

  return (
    <div className="space-y-5 max-w-xl">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <Star className="h-6 w-6 text-primary" /> Adresses favorites
        </h1>
        <p className="text-muted-foreground text-sm">Vos adresses fréquentes pour réserver plus vite.</p>
      </div>

      <Card className="p-4 rounded-md shadow-none">
        <div className="flex flex-wrap gap-2 items-end">
          <div className="flex-1 min-w-[120px]"><Label>Libellé</Label><Input value={form.label} onChange={(e) => setForm({ ...form, label: e.target.value })} placeholder="Domicile" className="mt-1" data-testid="fav-label" /></div>
          <div className="flex-[2] min-w-[200px]"><Label>Adresse</Label><Input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} placeholder="12 rue…" className="mt-1" data-testid="fav-address" /></div>
          <Button onClick={add} className="gap-2" data-testid="fav-add"><Plus className="h-4 w-4" /> Ajouter</Button>
        </div>
      </Card>

      <div className="space-y-2" data-testid="favorites-list">
        {favorites.length === 0 && <p className="text-sm text-muted-foreground">Aucune adresse favorite.</p>}
        {favorites.map((f) => (
          <Card key={f.id} className="p-3 rounded-md shadow-none flex items-center justify-between" data-testid={`fav-${f.id}`}>
            <div><p className="font-medium text-sm">{f.label}</p><p className="text-xs text-muted-foreground">{f.address}</p></div>
            <Button size="icon" variant="ghost" onClick={() => remove(f.id)} data-testid={`fav-delete-${f.id}`}><Trash2 className="h-4 w-4 text-destructive" /></Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
